<template>
	<div>
		<template v-if="headerShow">

			<div class="headerBox" @mouseenter="mouseover" @mouseleave="mouseout"
				:style="headerHover?'background-color:#FFFFFF;border: 1px solid #DADADA;':scrollTop>100?'background-color:rgba(0,0,0,0.2);':''"
				:class="{ 'nav-hidden': navHidden }">
				<div class="headerBox_cen">
					<div class="headerBox_img" @click="goIndex">
						<template v-if="logo2&&logo1">
							<img :src="logo2" v-if="headerHover" />
							<img :src="logo1" v-else />
						</template>
					</div>
					<div class="headerBox_li" :class="headerHover?'headerBox_list_two':'headerBox_list'">
						<ul>
							<template v-for="(item,index) in list">
								<li @click="goPath(item)"
									v-if="item.value!=='recruit'&&item.value!=='cbi'||item.value=='recruit'&&locale=='zh'||item.value=='cbi'&&locale=='zh'"
									:key="index" :class="current==item.value?'xz':'wxz'"
									@mouseenter="mouseoverLi(index)" @mouseleave="mouseoutLi(index)">
									<div class="top">
										<div class="top_til">
											{{item.name}}
										</div>
										<!-- v-if="item.show&&item.childe&&!navHidden" -->
										<div class="dw" :ref="`dw${index}`" v-if="item.show&&item.childe&&!navHidden">
											<ul>
												<li @mouseenter="mouseoverLiTwo(indexa)"
													@mouseleave="mouseoutLiTwo(indexa)"
													v-for="(itema,indexa) in item.childe" :key="indexa"
													:style="childXz==indexa?'color:#000;':''"
													@click.stop="goPathTo(itema)" :title="locale=='zh'?'':itema.name">
													{{itema.name}}
												</li>
											</ul>
											<div class="bj" :style="{
											height:bjHeight+'px'
										}"></div>
										</div>
									</div>

								</li>
							</template>
						</ul>
					</div>
					<!-- <div class="headerBox_ss">
					<img src="@/assets/header/ss.png" v-if="headerHover" />
				</div> -->
					<div :class="headerHover?'headerBox_lang_two':'headerBox_lang'">
						<div class="lang" @mouseenter="mouseoverLang()" @mouseleave="mouseoutLang()">
							<div class="langTil">
								<span v-if="locale === 'eu'" class="wz"
									:style="headerHover?'color: #000;':'color: #fff;'">EU-English</span>
								<span v-if="locale === 'en'" class="wz"
									:style="headerHover?'color: #000;':'color: #fff;'">Global-English</span>
								<span v-if="locale === 'zh'" class="wz"
									:style="headerHover?'color: #000;':'color: #fff;'">China-中文</span>
								<img src="@/assets/header/jtTwo.png" v-if="headerHover&&langShow==false" class="img" />
								<img src="@/assets/header/jtThree.png" v-else-if="headerHover&&langShow" class="img" />
								<img src="@/assets/header/jt.png" v-else class="img" />
							</div>
							<!-- v-if="langShow&&!navHidden" -->
							<div class="langdw" v-if="langShow&&!navHidden">
								<ul>
									<!-- :style="locale === 'en'?'color: #000;':'color: #686868;'" -->
									<li @click="changeLanguage('eu')">EU-English</li>
									<li @click="changeLanguage('en')">Global-English</li>
									<!-- :style="locale === 'zh'?'color: #000;':'color: #686868;'" -->
									<li @click="changeLanguage('zh')">
										China-中文
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="headerXian" v-if="headerHover&&!navHidden&&xianShow"></div>
			</div>
		</template>
		<!-- :class="{ 'nav-hidden': navHidden }" -->
		<div class="h5Head" v-else :class="{ 'nav-hidden': navHidden }">
			<div class="h5HeadBox_img" @click="goIndex">
				<img :src="logo2" />
			</div>
			<div @click="h5Tab=true">
				<i class="el-icon-s-unfold" style="font-size: 28px;color: $fff;"></i>
			</div>
		</div>
		<el-drawer title="" :visible.sync="h5Tab" :before-close="handleClose" direction='ltr' :append-to-body="true"
			size="50%">
			<el-menu class="el-menu-vertical-demo">
				<template v-for="(item,index) in list">
					<template v-if="item.childe">
						<el-submenu :index="index+''">
							<template slot="title">
								<span slot="title">{{item.name}}</span>
							</template>
							<el-menu-item-group v-for="(itema,indexa) in item.childe">
								<el-menu-item :index="index+'-'+indexa"
									@click="goPathTo(itema)">{{itema.name}}</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</template>
					<template v-else>
						<el-menu-item :index="index+''" @click="goPath(item)">
							<span slot="title">{{item.name}}</span>
						</el-menu-item>
					</template>
				</template>
			</el-menu>
		</el-drawer>
		<el-backtop :bottom='100'></el-backtop>
		<el-backtop ref="backOne" :bottom="40" :visibility-height="0" @click="goBack" v-if="!isTabShow">
			<div>
				<i class="el-icon-arrow-left" style="font-size: 28px;"></i>
			</div>
		</el-backtop>
	</div>
</template>

<script>
	import {
		get_config
	} from "@/api/config.js"
	import {
		lang
	} from "moment";
	export default {
		components: {},
		props: {
			current: {
				typeof: String,
				default: 'souye'
			}
		},
		data() {
			return {
				list: [{
						name: this.$t('i18n_345'),
						value: 'souye',
						path: '/'
					},
					{
						name: this.$t('i18n_346'),
						value: "about",
						show: false,
						path: '/about',
						childe: [{
								name: this.$t('i18n_347'),
								value: 'gyah',
								path: 'about',
							},
							{
								name: this.$t('i18n_348'),
								value: 'tzzgx',
								path: 'abInvest',
							},
						]
					},
					{
						name: this.$t('i18n_349'),
						value: "news",
						path: '/news'
					},
					{
						name: this.$t('i18n_350'),
						value: "product",
						show: false,
						path: '/product',
						childe: [{
								name: this.$t('i18n_351'),
								value: 'njxt',
								path: 'product',
							},
							{
								name: this.$t('i18n_352'),
								value: 'dznj',
								path: 'product',
							},
							{
								name: this.$t('i18n_353'),
								value: 'zbcp',
								path: 'product',
							},
						]
					},
					{
						name: this.$t('i18n_354'),
						value: "innovation",
						show: false,
						path: '/innovation',
						childe: [{
								name: this.$t('i18n_355'),
								value: 'cxts',
								path: 'innovation',
							},
							{
								name: this.$t('i18n_356'),
								value: 'xxjs',
								path: 'innovation',
							},
							{
								name: this.$t('i18n_357'),
								value: 'zzgx',
								path: 'innovation',
							},
							{
								name: this.$t('i18n_358'),
								value: 'sjqy',
								path: 'innovation',
							},
						]
					},
					{
						name: this.$t('i18n_359'),
						value: "recruit",
						show: false,
						path: 'recruit',
						childe: [{
								name: this.$t('i18n_360'),
								value: 'shzp',
								path: 'recruitSociety'
							},
							{
								name: this.$t('i18n_361'),
								value: 'xyzp',
								path: 'recruitCampus'
							},
							// {
							// 	name: this.$t('i18n_362'),
							// 	value: 'xyzp',
							// 	path: 'recruitCampusDetail'
							// },
						]
					},
					{
						name: this.$t('i18n_363'),
						value: "contactUs",
						show: false,
						path: '/contact',
						childe: [{
								name: this.$t('i18n_364'),
								value: 'sqzx',
								path: 'contact',
							},
							{
								name: this.$t('i18n_365'),
								value: 'shfw',
								path: 'contact',
							},
							{
								name: this.$t('i18n_366'),
								value: 'hzzx',
								path: 'contact',
							},
						]
					},
					{
						name: 'CBI大赛',
						value: "cbi",
						path: 'http://cbi.aohua.com',
					}
				],
				locale: 'eu',
				headerHover: false,
				childXz: 0,
				langShow: false,
				headerTrue: false,
				scrollTop: 0,
				navHidden: false,
				logo1: "",
				logo2: '',
				bjHeight: "",
				xianShow: false,
				navHead: false,
				h5Tab: false,
				isTabShow: true
				// logo1:require('@/assets/header/logo.png'),
				// logo2:require('@/assets/header/logoTwo.png'),
			}
		},
		mounted() {
			let t = this;
			// 窗口小于1200隐藏导航栏
			// window.screen.width
			// window.innerWidth
			this.goSetHeader();
			console.log(this.headerShow)
			this.locale = this.$i18n.locale;
			console.log(this.$i18n.locale)
			window.addEventListener('scroll', this.handleScroll);
			this.getConfigList();

			if (this.locale != 'zh') {
				delete this.list[1].childe
				// this.list[1].childe.splice(1,1)
			}
			let aaheadHover = localStorage.getItem("headerHover") || false;
			if (!aaheadHover) {
				try {
					localStorage.removeItem('headerHover')
				} catch (e) {
					//TODO handle the exception
				}
			}
			this.navHead = aaheadHover;
			if (!this.headerShow) {
				let rout = location.pathname;
				if (rout == '/en' || rout == '/cn' || rout == '/') {
					this.isTabShow = true;
				} else {
					let routTwo = rout.split('/');
					let routThree = '/' + routTwo[routTwo.length - 1];
					let arrTwo = ['/about', '/abInvest', '/news', '/product', '/innovation', '/recruitSociety',
						'/recruitCampus', '/contact'
					];
					console.log(routThree, arrTwo.includes(routThree), 'aaaaaaaaaaaaaaaaaaaaaaaaaaa')
					if (arrTwo.includes(routThree)) {
						this.isTabShow = true;
					} else {
						this.isTabShow = false;
						this.$nextTick(function() {
							this.$refs.backOne.visible = true;
						})
					}
				}
			} else {
				this.isTabShow = true;
			}


		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		watch: {
			navHidden() {
				this.list.map(v => {
					v.show = false
				})
			},
			scrollTop(newa, old) {
				// if(old>newa&&newa==0){
				// 	let t=this;
				// 	let aaheadHover=localStorage.getItem("headerHover")||false;
				// 	if(!aaheadHover){
				// 		localStorage.removeItem('headerHover')
				// 	}
				// 	t.headerHover=aaheadHover
				// }
			}
		},
		methods: {
			goBack() {
				window.history.go(-1);
			},
			handleClose() {
				this.h5Tab = false
			},
			// 监听页面滚动
			handleScroll(e) {
				var element;
				if (this.nowVibe == 'pc') {
					element = document.documentElement
				} else {
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				this.scrollTop = element.scrollTop;

			},
			// 顶部移入
			mouseover() {
				this.navHead = true;
				if (this.headerTrue) {
					return
				}
				this.headerHover = true;
			},
			mouseout() {
				this.navHead = false;
				if (this.headerTrue) {
					return
				}
				this.headerHover = false;
			},
			// 一级菜单移入
			mouseoverLi(e) {
				this.headerHover = true;
				this.list[e].show = true;
				this.xianShow = true;
				this.$nextTick(() => {
					try {
						this.bjHeight = this.$refs['dw' + e][0].offsetHeight
					} catch (e) {
						//TODO handle the exception
					}
				})
				// if(this.locale=='en'){
				// 	this.$nextTick(()=>{
				// 		try{
				// 			this.bjHeight=this.$refs['dw'+e][0].offsetHeight
				// 		}catch(e){
				// 			//TODO handle the exception
				// 		}
				// 	})
				// }
			},
			mouseoutLi(e) {
				this.xianShow = false;
				this.list[e].show = false;
			},
			// 二级菜单移入
			mouseoverLiTwo(e) {
				this.childXz = e;
			},
			mouseoutLiTwo(e) {
				this.childXz = 0;
			},
			// 语言移入
			mouseoverLang() {
				this.xianShow = true;
				this.langShow = true;
			},
			mouseoutLang() {
				this.xianShow = false;
				this.langShow = false;
			},
			/* 切换语言 */
			changeLanguage(lang) {
				this.langShow = false;
				
				if (location.hostname == 'www.aohua.com') {
					if (lang == 'zh') {
						document.title = '澳华内镜';
						this.$router.push('/cn')
					} else if (lang == 'en') {
						document.title = 'Aohua Endoscopy';
						this.$router.push('/' + lang)
					}else{
						document.title = 'Aohua Endoscopy';
						window.open('https://ahgwoz.wangsjtest.cn/eu', '_self')
						return;
					} 
				} else {
					if (lang == 'zh') {
						document.title = '澳华内镜';
						window.open('https://www.aohua.com/cn', '_self')
						return;
					} else if (lang == 'en') {
						document.title = 'Aohua Endoscopy';
						window.open('https://www.aohua.com/en', '_self')
						return;
					}
				}
				this.$i18n.locale = lang;
				this.locale = this.$i18n.locale;
				localStorage.setItem("i18n-lang", lang);
				return;
				let str1 = this.$route.fullPath;
				let str2 = '';
				if (str1.includes('cn')) {
					str2 = str1.replace('cn', lang);
				} else {
					str2 = str1.replace('en', lang);
				}
				if (this.locale !== 'zh' && this.$route.path == '/recruit') {
					this.$router.push('/null')
				} else if (str2) {
					window.location.href = str2
				} else {
					window.location.reload()
				}
			},
			// 用户点击菜单栏
			goPath(item) {
				let t = this;
				console.log(item.path)
				if (!item.path) {
					return
				}
				if (item.value == 'cbi') {
					window.open(item.path, "_blank")
					return
				}
				console.log(item.path)
				if (t.$route.path != item.path) {
					if (item.path == '/') {
						if (this.locale == 'zh') {
							t.$router.push('/cn')
						} else if (this.locale == 'en') {
							t.$router.push('/en')
						} {
							t.$router.push('/eu')
						}
					} else {
						t.$router.push(item.path)
					}
				}
			},
			// 用户点击菜单栏
			goPathTo(item) {
				let t = this;
				if (!item.path) {

					return
				}
				let path = ('/' + item.path)
				console.log(path, t.$route.path)
				if (t.$route.path != path) {
					t.$router.push({
						push: '/' + item.path,
						name: item.path,
						query: {
							value: item.value
						}
					})
				} else {
					t.$router.replace({
						push: '/' + item.path,
						name: item.path,
						query: {
							value: item.value
						}
					})
				}
			},
			getConfigList() {
				let data = {};
				get_config(data).then(res => {
					console.log(res)
					this.logo1 = res.data.site_logo;
					this.logo2 = res.data.site_logo_select;
				}).catch(err => {
					console.log(err)
				})
			},
			goIndex() {
				let t = this;
				var element;
				if (this.nowVibe == 'pc') {
					element = document.documentElement
				} else {
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				if (t.$route.path == '/en' || t.$route.path == '/cn'|| t.$route.path == '/eu') {
					element.scrollTop = 0
					return
				}
				if (t.$route.path != '/') {
					if (this.locale == 'zh') {
						t.$router.push('/cn')
					} else if (this.locale == 'en') {
						t.$router.push('/en')
					}else{
						t.$router.push('/eu')
					}
				} else {
					element.scrollTop = 0
				}
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	// .headerBox:hover{
	// 	background-color:#FFFFFF;
	// 	border: 1px solid #DADADA;
	// }
	.nav-hidden {
		top: -100px !important;
	}

	.headerXian {
		position: fixed;
		top: 56px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #DADADA;
		z-index: 3;
	}

	.headerBox {
		transition: all .5s ease-out;
		position: fixed;
		top: 0;
		left: 0;
		// background-color: rgba(0, 0,0,0.3);
		width: 100%;
		// height: 56px;
		z-index: 99999;

		.headerBox_cen {
			width: 1200px;
			// height: 56px;
			margin: 0 auto;
			display: flex;

			// align-items: center;
			.headerBox_img {
				// width: 175px;
				// height: 30px;
				width: 175px;
				height: 56px;
				margin-right: 74px;
				display: flex;
				align-items: center;
				cursor: pointer;

				img {
					width: 175px;
					height: 30px;
				}
			}

			.headerBox_li {
				flex: 1;

				>ul {
					list-style: none;
					display: flex;
					// justify-content: center;
					padding: 0;
					margin: 0;
					position: relative;
					z-index: 9;

					>li:not(:last-child) {
						padding-right: 33px;
					}

					>li {
						font-size: 18px;
						// height: 56px;
						display: flex;
						// align-items: center;
						font-family: Source Han Sans CN;
						font-weight: 300;
						cursor: pointer;
						position: relative;
						z-index: 9;

						.top {
							.top_til {
								line-height: 56px;
								position: relative;
								// text-align: center;

								&:before {
									content: "";
									position: absolute;
									left: 50%;
									bottom: 0px;
									height: 2px;
									width: 0;
									background-color: #000;
									transition: all 0.3s ease-in-out;
									transform: translateX(-50%);
								}
							}
						}

						.dw {
							// position: absolute;
							// top: 54px;
							// left: -20px;
							min-width: 100%;
							// background-color: #fff;
							z-index: 2;
							// padding: 30px 20px 20px;
							// border-radius: 0 0 10px 10px;
							position: absolute;
							z-index: 9;
							padding-bottom: 30px;
							padding-top: 20px;

							>ul {
								position: relative;
								z-index: 99;
								list-style: none;
								width: 100%;
								padding: 0;

								>li:not(:last-child) {
									padding-bottom: 20px;
								}

								>li {
									color: #686868;
									font-size: 16px;
									font-family: Source Han Sans CN;
									font-weight: 300;
									width: 100%;
									white-space: nowrap;

									&:hover {
										font-weight: bold;
										color: #000;
									}
								}

							}
						}

						.bj {
							position: fixed;
							top: 57px;
							left: 0;
							width: 100%;
							height: 0px;
							z-index: 0;
							background-color: #fff;
						}

						&:hover .top_til::before {
							width: 100%;
						}

					}

				}
			}

			.headerBox_list {
				flex: 1;

				>ul {
					>li {
						color: #FFFFFF;
					}
				}
			}

			.headerBox_list_two {
				>ul {
					>li {
						color: #000;
					}

				}

			}

			.headerBox_ss {
				flex: 1;
				width: 17px;

				img {
					width: 17px;
					height: 17px;
				}
			}
		}

		.lang {
			position: relative;
			// width: 145px;
			cursor: pointer;

			.langTil {
				position: relative;
				width: 150px;
				height: 56px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				&:before {
					content: "";
					position: absolute;
					left: 50%;
					bottom: -2px;
					height: 4px;
					width: 0;
					background-color: #000;
					transition: all 0.3s ease-in-out;
					transform: translateX(-50%);
					opacity: 0;
				}
			}

			&:hover .langTil::before {
				width: 100%;
			}

			.langdw {
				// position: absolute;
				// top: 30px;

				// left: -20px;
				min-width: 100%;
				// background-color: #fff;
				z-index: 2;
				// padding: 30px 20px 20px;
				// border-radius: 0 0 10px 10px;
				padding-bottom: 30px;

				>ul {
					border: none;
					list-style: none;
					width: 100%;
					padding: 0;

					// background-color: #fff;
					>li:first-child {
						padding-top: 20px;
						margin-top: -4px;
					}

					>li:not(:last-child) {
						padding-bottom: 30px;
					}

					>li {
						color: #686868;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						width: 100%;
						cursor: pointer;

						&:hover {
							font-weight: bold;
							color: #000;
						}
					}
				}
			}

			.wz {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
			}

			.img {
				width: 14px;
				height: 8px;
				margin-left: 11px;
			}
		}
	}

	// 根据html lang 属性值进行样式修改
	[lang]:lang(en) {
		.headerBox {
			.top {
				.top_til {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					// width:100px;
				}

				.dw {
					position: absolute;
					z-index: 9;

					ul {
						position: relative;
						z-index: 99;

						li {
							// width:100px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}

					.bj {
						position: fixed;
						top: 57px;
						left: 0;
						width: 100%;
						height: 0px;
						z-index: 0;
						background-color: #fff;
					}
				}
			}

		}
	}

	@media screen and (max-width:1200px) {
		.h5Head {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			z-index: 99999;
			display: flex;
			background-color: #FFFFFF;
			justify-content: space-between;
			align-items: center;
			padding: 0 30px;
			box-sizing: border-box;

			.h5HeadBox_img {
				width: 179px;
				height: 56px;
				display: flex;
				align-items: center;
				cursor: pointer;

				img {
					// width: 175px;
					height: 22px;
					object-fit: contain;
				}
			}
		}

		.el-drawer__wrapper {
			width: 100vw;
		}
	}
</style>